import { buildURL } from 'react-imgix';
import { IMAGE_DEFAULT_QUALITY } from './constants';
export const getPreviewUrl = ({
  previewWidth = 100,
  previewQuality = 30,
  previewImgixParams = {},
  src
}) => buildURL(src, {
  auto: 'format',
  w: previewWidth,
  q: previewQuality,
  ...previewImgixParams
});
export const applyForDpr = (values, dpr) => {
  if (typeof values === 'number') {
    return values;
  }
  if (dpr === 5) {
    return values[5] ?? values[4] ?? values[3] ?? values[2] ?? values[1];
  }
  if (dpr === 4) {
    return values[4] ?? values[3] ?? values[2] ?? values[1];
  }
  if (dpr === 3) {
    return values[3] ?? values[2] ?? values[1];
  }
  if (dpr === 2) {
    return values[2] ?? values[1];
  }
  return values[1];
};
export const getQuality = (quality, defaultQuality, dpr) => quality ?? defaultQuality ?? IMAGE_DEFAULT_QUALITY[dpr];